
export interface Props {
  campaignId: string
  campaignName: string
  isMobile: boolean
}

const init = (props: Props) => {
  window.addEventListener("load", () => {
    const allMagazinesButton = document.querySelector(".issue-section-button-container");

    allMagazinesButton.addEventListener("click", () => {
      window.dataLayer.push({
        event: "cta_click",
        click_type: "cta_all_your_favourite_magazines",
        campaign_id: props.campaignId,
        campaign_name: props.campaignName
      });
    })
  });
}

export const CoverWall = {
  init
}